export const ROSTER = '[ROSTER]'
export const INIT_ROSTER = `${ROSTER} Set initial roster members`
export const ADD_TO_ROSTER = `${ROSTER} Add new roster members`

export const initialiseRoster = () => ({
    type: INIT_ROSTER,
    payload: {},
    meta: {
        persisted: 'roster',
        checkRoster: 'initialiseSquad',
    },
})

export const addToRoster = baseUnits => ({
    type: ADD_TO_ROSTER,
    payload: {
        baseUnits,
    },
    meta: {
        persisted: 'roster',
    },
})
